import React from "react";

function NormalCalculator() {
  const handleClick = (value) => {
    const output = document.getElementById("frNormalOutput");
    if (!output) return;
    let current = output.innerHTML === "0" ? "" : output.innerHTML;

    if (value === "C") {
      output.innerHTML = "0";
    } else if (value === "\u232b") {
      output.innerHTML = current.length > 1 ? current.slice(0, -1) : "0";
    } else if (value === "=") {
      try {
        // eslint-disable-next-line no-eval
        let result = eval(current.replace(/\u00f7/g, "/").replace(/\u00d7/g, "*"));
        output.innerHTML = String(result);
      } catch {
        output.innerHTML = "Erreur";
      }
    } else if (value === "+/-") {
      if (current !== "" && current !== "0") {
        output.innerHTML = current.startsWith("-") ? current.slice(1) : "-" + current;
      }
    } else if (value === "sqrt") {
      try {
        let result = Math.sqrt(parseFloat(current));
        output.innerHTML = String(result);
      } catch {
        output.innerHTML = "Erreur";
      }
    } else {
      output.innerHTML = (current === "" ? "" : current) + value;
    }
  };

  return (
    <div style={{ width: "100%", maxWidth: "400px", margin: "0 auto" }}>
      <style>{`
        #frNormalOut {
          padding: 20px;
          border: 2px solid #1a5f3f;
          border-radius: 16px;
          background: linear-gradient(135deg, #ffffff 0%, #f8fbf9 100%);
          box-shadow: 0 8px 25px rgba(26, 95, 63, 0.12);
          max-width: 380px;
          margin: 0 auto;
        }
        #frNormalOutput {
          font-size: 32px;
          font-weight: 700;
          padding: 18px 20px;
          margin: 0 0 18px 0;
          text-align: right;
          background: linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%);
          border: none;
          border-radius: 12px;
          color: #ffffff;
          min-height: 70px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          box-shadow: 0 4px 12px rgba(26, 95, 63, 0.25);
          letter-spacing: 1px;
          word-break: break-all;
        }
        .frnm {
          display: inline-block; vertical-align: middle; text-align: center;
          width: 62px; height: 62px; line-height: 62px; margin: 4px;
          border: 2px solid #1a5f3f; border-radius: 14px;
          font-size: 22px; font-weight: 700; color: #ffffff;
          background: linear-gradient(135deg, #1a5f3f 0%, #2d8a5f 100%);
          cursor: pointer; transition: all 0.2s ease;
          box-shadow: 0 4px 8px rgba(26, 95, 63, 0.2); user-select: none;
        }
        .frnm:hover { background: linear-gradient(135deg, #2d8a5f 0%, #3a9f6f 100%); transform: translateY(-2px); }
        .frnm:active { background: linear-gradient(135deg, #0f3d28 0%, #1a5f3f 100%); transform: translateY(0); }
        .frop {
          display: inline-block; vertical-align: middle; text-align: center;
          width: 62px; height: 62px; line-height: 62px; margin: 4px;
          border: 2px solid #e2e8f0; border-radius: 14px;
          font-size: 22px; font-weight: 700; color: #1a5f3f; background: #ffffff;
          cursor: pointer; transition: all 0.2s ease;
          box-shadow: 0 2px 6px rgba(0,0,0,0.08); user-select: none;
        }
        .frop:hover { background: #f0f7f4; border-color: #1a5f3f; transform: translateY(-2px); }
        .frop:active { background: #1a5f3f; color: #ffffff; transform: translateY(0); }
        .freq {
          display: inline-block; vertical-align: middle; text-align: center;
          width: 62px; height: 62px; line-height: 62px; margin: 4px;
          border: 2px solid #d4af37; border-radius: 14px;
          font-size: 22px; font-weight: 700; color: #0f3d28;
          background: linear-gradient(135deg, #d4af37 0%, #f0d875 100%);
          cursor: pointer; transition: all 0.2s ease;
          box-shadow: 0 4px 8px rgba(212,175,55,0.3); user-select: none;
        }
        .freq:hover { background: linear-gradient(135deg, #f0d875 0%, #fae89e 100%); transform: translateY(-2px); }
        .freq:active { background: linear-gradient(135deg, #b89530 0%, #d4af37 100%); transform: translateY(0); }
        .frbs {
          display: inline-block; vertical-align: middle; text-align: center;
          width: 62px; height: 62px; line-height: 62px; margin: 4px;
          border: 2px solid #dc3545; border-radius: 14px;
          font-size: 20px; font-weight: 700; color: #ffffff;
          background: linear-gradient(135deg, #dc3545 0%, #e85d6b 100%);
          cursor: pointer; transition: all 0.2s ease;
          box-shadow: 0 4px 8px rgba(220,53,69,0.3); user-select: none;
        }
        .frbs:hover { background: linear-gradient(135deg, #e85d6b 0%, #f28790 100%); transform: translateY(-2px); }
        .frbs:active { background: linear-gradient(135deg, #bd2130 0%, #dc3545 100%); transform: translateY(0); }
        @media (max-width: 480px) {
          #frNormalOut { padding: 15px; max-width: 100%; border-radius: 12px; }
          #frNormalOutput { font-size: 26px; padding: 15px; min-height: 60px; }
          .frnm, .frop, .freq, .frbs { width: 56px; height: 56px; line-height: 56px; margin: 3px; font-size: 20px; border-radius: 12px; }
        }
        @media (max-width: 360px) {
          .frnm, .frop, .freq, .frbs { width: 50px; height: 50px; line-height: 50px; margin: 2px; font-size: 18px; }
          #frNormalOutput { font-size: 22px; }
        }
      `}</style>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          <tr>
            <td id="frNormalOut">
              <div>
                <div id="frNormalOutput">0</div>
              </div>
              <div style={{ paddingTop: "5px" }}>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick(7)} className="frnm">7</span>
                  <span onClick={() => handleClick(8)} className="frnm">8</span>
                  <span onClick={() => handleClick(9)} className="frnm">9</span>
                  <span onClick={() => handleClick("\u00f7")} className="frop">&divide;</span>
                  <span onClick={() => handleClick("\u232b")} className="frbs">&#x232B;</span>
                </div>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick(4)} className="frnm">4</span>
                  <span onClick={() => handleClick(5)} className="frnm">5</span>
                  <span onClick={() => handleClick(6)} className="frnm">6</span>
                  <span onClick={() => handleClick("\u00d7")} className="frop">&times;</span>
                  <span onClick={() => handleClick("+/-")} className="frop">&plusmn;</span>
                </div>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick(1)} className="frnm">1</span>
                  <span onClick={() => handleClick(2)} className="frnm">2</span>
                  <span onClick={() => handleClick(3)} className="frnm">3</span>
                  <span onClick={() => handleClick("-")} className="frop">&minus;</span>
                  <span onClick={() => handleClick("sqrt")} className="frop">&#x221A;x</span>
                </div>
                <div style={{ textAlign: "center" }}>
                  <span onClick={() => handleClick(0)} className="frnm">0</span>
                  <span onClick={() => handleClick(".")} className="frnm">.</span>
                  <span onClick={() => handleClick("+")} className="frop">+</span>
                  <span onClick={() => handleClick("C")} className="freq">C</span>
                  <span onClick={() => handleClick("=")} className="freq">=</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default NormalCalculator;